/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { EnumDescriptorsMap } from './interfaces';
import type { TransportRequestOptions, TransportService } from '../../../core';
import type { BaseRequestData, RequestErrorResponse, RequestSuccessResponse } from '../../../interfaces';

export class CommonSupplier {

    protected readonly transportService: TransportService<RequestErrorResponse | Error>;

    constructor(transportService: TransportService<RequestErrorResponse | Error>) {
        this.transportService = transportService;
    }

    getEnumDescriptors(url: string, data?: BaseRequestData, options?: Partial<TransportRequestOptions>) {
        return this.transportService.request<BaseRequestData, RequestSuccessResponse<EnumDescriptorsMap> | RequestErrorResponse | Error>(url, data, {
            ...options,
            noAuth: true,
        });
    }

}
